const UA = "quizrun-admin";

/**
 * Nominatim names some cities after their administrative region (e.g. a pin in
 * Hammersmith resolves to city "Greater London"), which would create a second
 * city alongside the existing one. Map those to the common city name.
 */
const CITY_ALIASES: Record<string, string> = {
  "Greater London": "London",
};

export function normalizeCity(city: string): string {
  return CITY_ALIASES[city] ?? city;
}

/** Forward geocode a query string via Nominatim. Returns [lat, lng] or null. */
export async function geocode(query: string): Promise<[number, number] | null> {
  const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1`;
  const res = await fetch(url, { headers: { "User-Agent": UA } });
  const data = await res.json();
  if (data.length > 0) return [parseFloat(data[0].lat), parseFloat(data[0].lon)];
  return null;
}

/** Reverse geocode coordinates via Nominatim. Returns { city, country, name } or null. */
export async function reverseGeocode(
  lat: number,
  lng: number,
): Promise<{ city: string; country: string; name: string } | null> {
  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=en&zoom=18`;
  const res = await fetch(url, { headers: { "User-Agent": UA } });
  const data = await res.json();
  if (!data?.address) return null;
  const a = data.address;
  return {
    city: normalizeCity(a.city || a.town || a.village || a.municipality || ""),
    country: a.country || "",
    name: data.name || a.amenity || a.building || a.leisure || "",
  };
}

/** Build a Google Maps search link for a city/country pair. */
export function mapsSearchLink(city: string, country?: string): string {
  const q = [city, country].filter(Boolean).join(",");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}
